export default "__VITE_ASSET__C2rdw2SU__"